import React, { Suspense, useEffect } from "react";

import { Card, CardBody, CardGroup, Col, Container, Row } from "reactstrap";
import {
  Input,
  Divider,
  Switch,
  Modal,
  Select,
  Form,
  Button,
  InputNumber,
} from "antd";
import { Link, Redirect } from "react-router-dom";
import "./Login.scss";
import { useSelector, useDispatch } from "react-redux";
import "react-phone-input-2/lib/style.css";
import { useState } from "react";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import SelectLang from "../../Components/SelectLanguage/SelectLang";
import useFetch from "../../Controllers/useFetch";
import Axios from "axios";
import { baseUrl } from "../../Controllers/rest_api_config";
import { user_account_level, user_role, logged_in } from "../../Redux/actions";
import Cookies from "js-cookie";
import { error, success, warning } from "../../Controllers/toast";
import MobileValidation from "./mobileValidation";
import { gql, useMutation } from "@apollo/client";
import {
  HashingPassword,
  decodedToken,
} from "../../Controllers/passwordHasher";
import TepayaLogo from "../../Assets/img/brand/logo.svg";

// import solarImg from '../../../../public/assets/img/solar-panel-login.jpg';

const LOGIN = gql`
  mutation loginUser(
    $email: String
    $password: String
    $mobile: String
    $device_id: Int
  ) {
    Login(
      loginInput: {
        email: $email
        password: $password
        mobile: $mobile
        device_id: $device_id
      }
    ) {
      user_id
      firstname
      lastname
      mobile
      email
      role
      account_level
      token
    }
  }
`;

const Login = () => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const userRole = useSelector((state) => state.user_role);

  const dispatch = useDispatch();

  const [user, setUser] = useState("");
  const [visible, setVisible] = useState(false);
  const [permission, setPermission] = useState(false);
  const [checkMobile, setCheckMobile] = useState(false);
  const [destination, setDestination] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [remmemberMe, setRemmemberMe] = useState(false);
  const [loginForm, setLoginForm] = useState();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [deviceId, setDeviceId] = useState(
    window.localStorage.getItem("device_id")
  );

  useEffect(() => {
    if (!deviceId) {
      const random = Math.floor(Math.random() * 1000000000);
      setDeviceId(random);
      window.localStorage.setItem("device_id", random);
    }
  });

  const [userLogin] = useMutation(LOGIN, {
    onCompleted: (res) => {
      // console.log(res);
      if (res.Login.user_id && res.Login.token) {
        logged_in(true);
        setSubmitLoading(false);
        setPermission(true);
        window.localStorage.setItem("m_t_s", res.Login.token);
        dispatch(user_role(res.Login.role));
        dispatch(user_account_level(res.Login.account_level));
        Cookies.set("token", res.Login.token, { expires: 7 });
        Cookies.set("user_role", res.Login.role);
        window.localStorage.setItem("firstname", res.Login.firstname);
        window.localStorage.setItem("lastname", res.Login.lastname);
        window.localStorage.setItem("email", res.Login.email);
        window.localStorage.setItem("mobile", res.Login.mobile);
        Cookies.set("account_level", res.Login.account_level);
        success("شما با موفقیت وارد شدید!");
      } else {
        setSubmitLoading(false);

        error("مشکلی رخ داده است!");
      }
    },
    onError: (err) => {
      setSubmitLoading(false);

      console.log(err.networkError, err.clientErrors, err.name, err.message);
      if (err.message) {
        if (err.message === "Failed to fetch") {
          error("ارتباط شما با اینترنت قطع است!");
        } else error(err.message);
      } else {
        error("مشکلی در ارتباط با سرور رخ داده است!");
      }
    },
  });

  const showModal = (type) => {
    setVisible(true);
    if (type === "DEMO") {
      setDestination("/#/choice_fact");
      Cookies.set("user_role", "owner", { expires: 1 });
      Cookies.set("token", "1234", { expires: 1 });
      Cookies.set("account_level", "regular", { expires: 1 });
      window.localStorage.setItem("firstname", "علی");
      window.localStorage.setItem("lastname", "علیزاده");
      window.localStorage.setItem("email", "dhuhapower@gmail.com");
    } else if (type === "LOGIN") {
      setCheckMobile(true);
      // console.log("in the LOGIN ShowModal")
    } else {
      setDestination("/#/register");
    }
  };

  const SendMobileAuth = () => {
    userLogin({
      variables: {
        mobile: phoneNumber,
        device_id: parseInt(deviceId),
      },
    });
  };

  const onFinish = async (values) => {
    setLoginForm(values);
    userLogin({
      variables: {
        email: values.email,
        password: await HashingPassword(values.password),
        device_id: parseInt(deviceId),
      },
    });
  };
  // console.log(remmemberMe);

  // if (
  //   permission === true &&
  //   Cookies.get("token") &&
  //   window.localStorage.getItem("m_t_s") === Cookies.get("token") &&
  //   (userRole === "owner" || userRole === "owner")
  // ) {
  //   return <Redirect to="/admin_panel" />;
  // } else 
  if (permission === true && user !== undefined 
    // && user !== "admin"
  ) {
    return <Redirect to="/choice_fact" />;
  } else {
    return (
      <div
        className="app animated fadeIn flex-row align-items-center login-background"
        style={{}}
      >
        <Container className="m-auto">
          <Row className="justify-content-center" style={{}}>
            <Col sm="8" xl="5" md="6">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Row>
                      <Col
                        className="text-center"
                        md={12}
                        xs={12}
                        sm={12}
                        lg={12}
                      >
                        <div>
                          <img src={TepayaLogo} width={72} />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={8} xs={12} sm={12} lg={8}>
                        <span className="h2 text-right">
                          {lang_choiced.pages.login.title}
                        </span>
                      </Col>
                      <Col md={4} xs={12} sm={12} lg={4}>
                        <SelectLang
                          className="lang-style text-right"
                          style={{ width: "16px" }}
                        />
                      </Col>
                    </Row>
                    {/* <Divider style={{ backgroundColor: "black" }} /> */}
                    <Form
                      onFinish={onFinish}
                      initialValues={{
                        email: Cookies.get("email_auth")
                          ? Cookies.get("email_auth")
                          : "",
                      }}
                    >
                      <Form.Item name="email">
                        <Input
                          style={{
                            direction: "ltr !mportant",
                            textAlign: "left !important",
                          }}
                          className="login-form-style input-ltr"
                          size="large"
                          placeholder="Email"
                          autoComplete="email"
                          prefix={<UserOutlined className="Icon-style" />}
                          // onChange={handleChangeUser}
                          type="email"
                        />
                      </Form.Item>
                      <Form.Item name="password">
                        <Input
                          style={{
                            direction: "ltr !mportant",
                            textAlign: "left !important",
                          }}
                          className="login-form-style input-ltr"
                          size="large"
                          placeholder="Password"
                          autoComplete="password"
                          prefix={<LockOutlined className="Icon-style" />}
                          // onChange={handleChangePass}
                          type="password"
                        />
                      </Form.Item>
                      <Row style={{ marginBottom: "30px" }}>
                        <Col
                          sm={6}
                          xs={6}
                          md={6}
                          lg={6}
                          xl={6}
                        
                          className="save-btn"
                        >
                          <Switch
                            size="small"
                            onChange={async (e) => {
                              await setRemmemberMe(e);
                            }}
                          />
                          <span>{" "}{lang_choiced.pages.login.forms.save}</span>
                        </Col>
                        <Col
                          sm={6}
                          xs={6}
                          md={6}
                          lg={6}
                          xl={6}
                          
                          className="remember-btn"
                        >
                          {/* <Link to="/remmember">
                            {lang_choiced.pages.login.forms.remember}
                          </Link> */}
                        </Col>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Col sm={12} xs={12} md={12} lg={12} xl={12}>
                          <Form.Item>
                            <Button
                              loading={submitLoading}
                              htmlType="submit"
                              danger
                              type="primary"
                              className=" login-button "
                              style={{ fontSize: 18 }}
                              onClick={() => {
                                setSubmitLoading(true);
                                // console.log("in the LoginFinalize");
                                if (remmemberMe === true) {
                                  Cookies.set("email_auth", loginForm.email);
                                }
                                // username === "admin" && password === "admin"
                                //   ?<Redirect to="/choice_fact" />
                                //   : "";
                                // setUser([JSON.stringify(username), password]);
                                // console.log("use and pass is :", user);
                                // return(<Redirect to="/choice_fact" />)
                              }}
                            >
                              {lang_choiced.pages.login.forms.btnLogin}
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row className="text-center">
                        <Col>
                          <Button
                            type="text"
                            onClick={() => {
                              showModal("LOGIN");
                            }}
                          >
                            {" "}
                            {lang_choiced.pages.login.forms.btnMobileLogin}
                          </Button>
                        </Col>
                      </Row>
                      {/* <Divider>{lang_choiced.pages.login.forms.or}</Divider>
                      <Row style={{ textAlign: "center" }}>
                        <Col sm={12} xs={12} md={12} lg={12} xl={12}>
                          <Link to="/register">
                            <Button
                              type="link"
                              onClick={() => {
                                // showModal("register")
                              }}
                            >
                              {lang_choiced.pages.login.forms.btnRegister}
                            </Button>
                          </Link>
                          <Divider type="vertical" />
                          <Button type="link" onClick={() => showModal("DEMO")}>
                          {lang_choiced.pages.login.forms.btnDemo}
                          </Button>
                        </Col>
                      </Row> */}
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>

          <MobileValidation
            setMobile={(phone) => {
              setPhoneNumber(phone);
            }}
            checkMobile={checkMobile}
            setVisible={(value) => setVisible(value)}
            visible={visible}
            setResponse={(value) => {
              // if (value === true) {
              //   window.location.replace(destination);
              // } else {
              SendMobileAuth();
              // }
            }}
          />
        </Container>
      </div>
    );
  }
};

export default Login;
